import React from 'react';
import { Card, CardTitle } from 'material-ui/Card';
import { List, ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';

const style = { flex: 1 };

export default ({ orders = [], customers = {} }) => (
    <Card style={style}>
        <CardTitle title="Pending Orders" />
        
        <List>
            {orders.map(record =>
                <ListItem
                    key={record.cc_id}
                    href={`#/commands/${record.id}`}
                    primaryText={new Date(record.date).toLocaleString('en-GB')}
                    secondaryText={
                        <p>
                           {record.count}-
                           {record.buisiness_id}

                        </p>
                    }
                  
                />
            )}
        </List>
    </Card>
);



// WEBPACK FOOTER //
// ./src/dashboard/PendingOrders.js